import React from "react";
import PropTypes from "prop-types";

import { getIconComponent } from "./iconRegistry";

const Icon = ({ name, className, fontSize = "inherit", ...rest }) => {
  const IconComponent = getIconComponent(name);

  if (IconComponent === null) {
    return null;
  }

  return <IconComponent className={className} fontSize={fontSize} {...rest} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  fontSize: PropTypes.oneOf(["inherit", "small", "medium", "large"]),
};

export default Icon;
